import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Refresh, Add } from '@material-ui/icons';
import { getListeClient } from '../../actions';
import { apiATC } from '../../config';
import {
  fetchComptePoidsBalances,
  setComptePoidsFilter,
  setComptePoidsDates,
  createEntreeBroutille,
  createRetourAvoir,
  clearComptePoidsError
} from '../../actions/comptePoids';
import {
  selectFilteredComptePoidsItems,
  selectComptePoidsTotal,
  selectComptePoidsFilter,
  selectComptePoidsStatus,
  selectClientsForComptePoids,
  selectComptePoidsDateDebut,
  selectComptePoidsDatFin
} from '../../selectors/comptePoids';
import BalancesTable from '../../components/comptePoids/BalancesTable';
import OperationModal from '../../components/comptePoids/OperationModal';
import OperationsDrawer from '../../components/comptePoids/OperationsDrawer';

const ComptePoidsClients = (props) => {
  const {
    clients,
    items,
    total,
    filterClientId,
    status,
    reduxDateDebut,
    reduxDateFin,
    fetchComptePoidsBalances,
    setComptePoidsFilter,
    setComptePoidsDates,
    createEntreeBroutille,
    createRetourAvoir,
    getListeClient,
    clearComptePoidsError
  } = props;

  const currentYear = new Date().getFullYear();
  const [modalOpen, setModalOpen] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const [operations, setOperations] = useState([]);
  const [facturesFacon, setFacturesFacon] = useState([]);
  const [loadingOps, setLoadingOps] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  // Dates persistées dans Redux, avec fallback sur currentYear
  const dateDebut = reduxDateDebut || `${currentYear}-01-01`;
  const dateFin = reduxDateFin || `${currentYear}-12-31`;
  
  // State local pour modification des dates
  const [tempDateDebut, setTempDateDebut] = useState(dateDebut);
  const [tempDateFin, setTempDateFin] = useState(dateFin);

  useEffect(() => {
    getListeClient();
  }, [getListeClient]);

  useEffect(() => {
    const defaultDateDebut = reduxDateDebut || `${currentYear}-01-01`;
    const defaultDateFin = reduxDateFin || `${currentYear}-12-31`;
    fetchComptePoidsBalances(null, defaultDateDebut, defaultDateFin);
    setTempDateDebut(defaultDateDebut);
    setTempDateFin(defaultDateFin);
  }, [currentYear, reduxDateDebut, reduxDateFin, fetchComptePoidsBalances]);

  useEffect(() => {
    const client = clients.find(c => String(c.id) === String(filterClientId));
    setSearchTerm(client?.label || '');
  }, [filterClientId, clients]);

  const handleRowClick = async (row) => {
    setSelectedClient(row);
    setDrawerOpen(true);
    setLoadingOps(true);
    try {
      const opsParams = { action: 'compte_poids_operations', clientId: row.clientId };
      const faconsParams = { action: 'compte_poids_factures_facon', clientId: row.clientId };
      if (dateDebut) {
        opsParams.dateDebut = dateDebut;
        faconsParams.dateDebut = dateDebut;
      }
      if (dateFin) {
        opsParams.dateFin = dateFin;
        faconsParams.dateFin = dateFin;
      }
      const [opsRes, faconsRes] = await Promise.all([
        axios.get(`${apiATC}/metal/metal.php`, { params: opsParams }),
        axios.get(`${apiATC}/metal/metal.php`, { params: faconsParams })
      ]);
      setOperations(opsRes.data?.data || []);
      setFacturesFacon(faconsRes.data?.data || []);
      // Use ancienSolde from row (same value as in table column)
      setSelectedClient({ ...row, soldeAnterieur: row.ancienSolde });
    } catch (err) {
      console.error(err);
      setOperations([]);
      setFacturesFacon([]);
    } finally {
      setLoadingOps(false);
    }
  };

  const handleCloseDrawer = () => {
    setDrawerOpen(false);
    setSelectedClient(null);
    setOperations([]);
    setFacturesFacon([]);
  };

  const handleFilter = (cid) => {
    setComptePoidsFilter(cid);
    fetchComptePoidsBalances(cid || null, dateDebut, dateFin);
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
    setShowDropdown(true);
    if (!value) {
      handleFilter(null);
    }
  };

  const handleSelectClient = (client) => {
    handleFilter(client.id);
    setSearchTerm(client.label);
    setShowDropdown(false);
  };

  const handleClearClient = () => {
    handleFilter(null);
    setSearchTerm('');
    setShowDropdown(false);
  };

  const filteredClients = clients.filter(c =>
    c.label.toLowerCase().includes(searchTerm.toLowerCase())
  ).slice(0, 50);

  const handleRefresh = () => {
    fetchComptePoidsBalances(filterClientId || null, dateDebut, dateFin);
  };

  const handleDateChange = (newDateDebut, newDateFin) => {
    setComptePoidsDates(newDateDebut, newDateFin);
    fetchComptePoidsBalances(filterClientId || null, newDateDebut, newDateFin);
  };

  const handleSubmit = (payload) => {
    const action = modalOpen === 'broutille' ? createEntreeBroutille : createRetourAvoir;
    return action(payload).finally(() => clearComptePoidsError());
  };

  return (
    <div style={{ 
      maxWidth: '1200px', 
      margin: '0 auto', 
      padding: '24px', 
      backgroundColor: '#f8f9fa', 
      minHeight: 'calc(100vh - 100px)' 
    }}>
      <div style={{ marginBottom: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
          <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 400, color: '#202124' }}>Compte Poids Clients</h2>
          <div style={{ 
            padding: '8px 16px', 
            backgroundColor: total >= 0 ? '#e8f5e9' : '#fce8e6',
            borderRadius: '20px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px'
          }}>
            <span style={{ fontSize: '13px', color: '#5f6368', fontWeight: 500 }}>Solde total</span>
            <span style={{ fontSize: '20px', fontWeight: 600, color: total >= 0 ? '#1e8e3e' : '#d93025' }}>
              {Number(total || 0).toFixed(2)} g
            </span>
          </div>
        </div>
        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={() => setModalOpen('broutille')}
            style={{
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: 500,
              color: '#fff',
              backgroundColor: '#1a73e8',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#1765cc'; e.target.style.boxShadow = '0 2px 6px rgba(0,0,0,0.16)'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = '#1a73e8'; e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12)'; }}
          >
            <Add fontSize="small" />
            Entrée broutille
          </button>
          <button
            onClick={() => setModalOpen('retour')}
            style={{
              padding: '10px 20px',
              fontSize: '14px',
              fontWeight: 500,
              color: '#1a73e8',
              backgroundColor: '#fff',
              border: '1px solid #dadce0',
              borderRadius: '4px',
              cursor: 'pointer',
              boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
              transition: 'all 0.2s',
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#f8f9fa'; e.target.style.borderColor = '#1a73e8'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = '#fff'; e.target.style.borderColor = '#dadce0'; }}
          >
            <Add fontSize="small" />
            Retour avoir
          </button>
        </div>
      </div>

      <div style={{ 
        marginBottom: '20px', 
        padding: '16px', 
        backgroundColor: '#fff', 
        borderRadius: '8px', 
        boxShadow: '0 1px 3px rgba(0,0,0,0.12)',
        display: 'flex',
        alignItems: 'center',
        gap: '24px',
        flexWrap: 'wrap'
      }}>
        {/* Client Filter */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: '0 0 auto', position: 'relative' }}>
          <label style={{ fontSize: '14px', fontWeight: 500, color: '#5f6368', whiteSpace: 'nowrap' }}>Client :</label>
          <div style={{ position: 'relative' }}>
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => handleSearchChange(e.target.value)}
              onFocus={() => setShowDropdown(true)}
              placeholder="Tous les clients"
              autoComplete="off"
              style={{
                padding: '8px 36px 8px 12px',
                fontSize: '14px',
                border: `1px solid ${filterClientId ? '#1a73e8' : '#dadce0'}`,
                borderRadius: '4px',
                outline: 'none',
                minWidth: '200px',
                backgroundColor: '#fff'
              }}
            />
            {filterClientId && (
              <button
                type="button"
                onClick={handleClearClient}
                style={{
                  position: 'absolute',
                  right: '8px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  background: 'none',
                  border: 'none',
                  color: '#5f6368',
                  cursor: 'pointer',
                  fontSize: '20px',
                  padding: '4px 8px',
                  lineHeight: '1',
                  display: 'flex',
                  alignItems: 'center'
                }}
                title="Effacer"
              >
                ×
              </button>
            )}
            {showDropdown && searchTerm && filteredClients.length > 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                minWidth: '250px',
                backgroundColor: '#fff',
                border: '1px solid #dadce0',
                borderRadius: '4px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                maxHeight: '250px',
                overflowY: 'auto',
                zIndex: 100,
                marginTop: '4px'
              }}>
                <div
                  onClick={() => handleClearClient()}
                  style={{
                    padding: '10px 12px',
                    fontSize: '14px',
                    color: '#5f6368',
                    cursor: 'pointer',
                    backgroundColor: !filterClientId ? '#e8f0fe' : 'transparent',
                    borderBottom: '1px solid #f1f3f4',
                    fontWeight: 500
                  }}
                  onMouseEnter={(e) => { e.target.style.backgroundColor = '#f8f9fa'; }}
                  onMouseLeave={(e) => { e.target.style.backgroundColor = !filterClientId ? '#e8f0fe' : 'transparent'; }}
                >
                  Tous les clients
                </div>
                {filteredClients.map(client => (
                  <div
                    key={client.id}
                    onClick={() => handleSelectClient(client)}
                    style={{
                      padding: '10px 12px',
                      fontSize: '14px',
                      color: '#202124',
                      cursor: 'pointer',
                      backgroundColor: String(client.id) === String(filterClientId) ? '#e8f0fe' : 'transparent',
                      borderBottom: '1px solid #f1f3f4'
                    }}
                    onMouseEnter={(e) => { e.target.style.backgroundColor = '#f8f9fa'; }}
                    onMouseLeave={(e) => { e.target.style.backgroundColor = String(client.id) === String(filterClientId) ? '#e8f0fe' : 'transparent'; }}
                  >
                    {client.label}
                  </div>
                ))}
              </div>
            )}
            {showDropdown && searchTerm && filteredClients.length === 0 && (
              <div style={{
                position: 'absolute',
                top: '100%',
                left: 0,
                minWidth: '250px',
                backgroundColor: '#fff',
                border: '1px solid #dadce0',
                borderRadius: '4px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                padding: '12px',
                marginTop: '4px',
                fontSize: '14px',
                color: '#5f6368',
                textAlign: 'center',
                zIndex: 100
              }}>
                Aucun client trouvé
              </div>
            )}
          </div>
        </div>

        {/* Date Filter */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flex: '1 1 auto' }}>
          <label style={{ fontSize: '14px', fontWeight: 500, color: '#5f6368', whiteSpace: 'nowrap' }}>Période :</label>
          <label style={{ fontSize: '13px', color: '#5f6368' }}>Du</label>
          <input
            type="date"
            value={tempDateDebut}
            onChange={(e) => setTempDateDebut(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleDateChange(tempDateDebut, tempDateFin)}
            onBlur={(e) => handleDateChange(tempDateDebut, tempDateFin)}
            style={{
              padding: '8px 12px',
              fontSize: '14px',
              border: '1px solid #dadce0',
              borderRadius: '4px',
              outline: 'none'
            }}
          />
          <label style={{ fontSize: '13px', color: '#5f6368' }}>au</label>
          <input
            type="date"
            value={tempDateFin}
            onChange={(e) => setTempDateFin(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleDateChange(tempDateDebut, tempDateFin)}
            onBlur={(e) => handleDateChange(tempDateDebut, tempDateFin)}
            style={{
              padding: '8px 12px',
              fontSize: '14px',
              border: '1px solid #dadce0',
              borderRadius: '4px',
              outline: 'none'
            }}
          />
          <button
            onClick={() => handleDateChange(dateDebut, dateFin)}
            style={{
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: 500,
              color: '#fff',
              backgroundColor: '#1a73e8',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              boxShadow: '0 1px 2px rgba(0,0,0,0.12)',
              transition: 'all 0.2s',
              whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#1765cc'; e.target.style.boxShadow = '0 1px 3px rgba(0,0,0,0.16)'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = '#1a73e8'; e.target.style.boxShadow = '0 1px 2px rgba(0,0,0,0.12)'; }}
          >
            Filtrer
          </button>
          <button
            onClick={() => {
              const year = new Date().getFullYear();
              handleDateChange(`${year}-01-01`, `${year}-12-31`);
            }}
            style={{
              padding: '8px 16px',
              fontSize: '14px',
              fontWeight: 500,
              color: '#5f6368',
              backgroundColor: '#fff',
              border: '1px solid #dadce0',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              whiteSpace: 'nowrap'
            }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#f8f9fa'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = '#fff'; }}
          >
            Réinitialiser
          </button>
          <button
            onClick={handleRefresh}
            style={{
              padding: '8px',
              fontSize: '14px',
              fontWeight: 500,
              color: '#5f6368',
              backgroundColor: '#fff',
              border: '1px solid #dadce0',
              borderRadius: '4px',
              cursor: 'pointer',
              transition: 'all 0.2s',
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              minWidth: '36px'
            }}
            onMouseEnter={(e) => { e.target.style.backgroundColor = '#f8f9fa'; }}
            onMouseLeave={(e) => { e.target.style.backgroundColor = '#fff'; }}
            title="Rafraîchir"
          >
            <Refresh fontSize="small" />
          </button>
        </div>
      </div>

      {status.error && (
        <div style={{ 
          padding: '12px 16px', 
          marginBottom: '16px', 
          backgroundColor: '#fce8e6', 
          color: '#c5221f', 
          borderRadius: '4px', 
          fontSize: '14px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
        }}>
          {status.error}
        </div>
      )}

      <BalancesTable items={items} loading={status.loading} onRowClick={handleRowClick} />

      <OperationModal
        isOpen={!!modalOpen}
        onClose={() => setModalOpen(null)}
        type={modalOpen}
        clients={clients}
        onSubmit={handleSubmit}
        posting={status.posting}
        defaultClientId={filterClientId}
      />

      <OperationsDrawer
        isOpen={drawerOpen}
        onClose={handleCloseDrawer}
        clientName={selectedClient?.clientName || ''}
        operations={operations}
        facturesFacon={facturesFacon}
        loading={loadingOps}
        dateDebut={dateDebut}
        dateFin={dateFin}
        soldeAnterieur={selectedClient?.soldeAnterieur || 0}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  clients: selectClientsForComptePoids(state),
  items: selectFilteredComptePoidsItems(state),
  total: selectComptePoidsTotal(state),
  filterClientId: selectComptePoidsFilter(state),
  reduxDateDebut: selectComptePoidsDateDebut(state),
  reduxDateFin: selectComptePoidsDatFin(state),
  status: selectComptePoidsStatus(state)
});

const mapDispatchToProps = {
  getListeClient,
  fetchComptePoidsBalances,
  setComptePoidsFilter,
  setComptePoidsDates,
  createEntreeBroutille,
  createRetourAvoir,
  clearComptePoidsError
};

export default connect(mapStateToProps, mapDispatchToProps)(ComptePoidsClients);
